import React, { useState } from "react";
import Modal from "../../components/Modals/Modal";
import { COLORS, SCAN_TYPES } from "../../config";
import { PopoverPicker } from "../../components/ColorPicker/PopoverPicker";
import SecondaryButtonAccent from "../../components/Buttons/SecondaryButtonAccent";
import ArrowExpand from '../../components/Icons/outline/ArrowExpand';
import STLViewer from "../../components/Viewers/STLViewer";

function STLViewerModal({
  showSTL,
  scanType,
  scanId,
  patientName,
  scanName,
  onClose,
}) {
  const [color, setColor] = useState(COLORS.colorPrimary);


  return (
    <Modal
      title={
        [SCAN_TYPES.FACE_SCAN, SCAN_TYPES.INTRORAL_SCAN].includes(scanType)
          ? "STL Viewer"
          : scanType
      }
      show={showSTL ? true : false}
      hide={onClose}
      className="min-w-max"
    >
      <div className="flex flex-col justify-between w-full my-5 stl-viewer">
        <div className="flex mb-1">
          <div className="font-bold mr-1">File Name:</div>
          <div className="max-w-md">{scanName}</div>
        </div>
        <div className="flex mb-3">
          <div className="font-bold mr-1">Patient Name:</div>
          <div className="">{patientName} </div>
        </div>

        {[SCAN_TYPES.FACE_SCAN, SCAN_TYPES.INTRORAL_SCAN].includes(
          scanType
        ) && (
          <div className="flex mb-3">
            {/* <PopoverPicker color={color} onChange={setColor} /> */}
            <SecondaryButtonAccent
              // className="ml-5"
              onClick={() => window.open(`/stl-viewer/${scanId}/${scanName}`)}
              text="Full Screen"
              icon={<ArrowExpand stroke={COLORS.colorPrimary}/>}
            />
          </div>
        )}

        <div className='flex justify-center mt-2' style={{backgroundColor: '#999999'}}>
          {[SCAN_TYPES.FACE_SCAN, SCAN_TYPES.INTRORAL_SCAN].includes(
            scanType
          ) && showSTL ? (
            <STLViewer url={showSTL} />
          ) : scanType === SCAN_TYPES.VIDEO ? (
            <video width="800" controls>
              <source src={showSTL} />
              Your browser does not support HTML video.
            </video>
          ) : (
            <img height={"auto"} width={500} src={showSTL} />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default STLViewerModal;
